import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import About from '@/components/About'
import Privacy from '@/components/Privacy'
import Map from '@/components/Map'
import PlaceQr from '@/components/PlaceQr'
import UserQr from '@/components/UserQr'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      beforeEnter: (to, from, next) => {
        if ('path' in to.query) {
          next({
            path: `/${to.query.path}`
          })
        } else {
          next(true)
        }
      }
    },
    {
      path: '/tag/:tagname',
      name: 'tag',
      beforeEnter: (to, from, next) => {
        next({
          path: `/map/search/${to.params.tagname}/@13.764955,100.538317,6,1,0`
        })
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/sendto/:uid',
      name: 'Sendto',
      beforeEnter: (to, from, next) => {
        if ('ppid' in to.query) {
          next({
            path: '/',
            query: {
              uid: to.params.uid,
              ppid: to.query.ppid
            }
          })
        } else {
          next({
            path: '/',
            query: {
              uid: to.params.uid
            }
          })
        }
      }
    },
    {
      path: '/map',
      name: 'Map',
      component: Map,
      children: [
        {
          path: 'search/:keyword/:latlonzoompageindex',
          name: 'Search'
        },
        {
          path: 'place/:id',
          name: 'Place',
          alias: '/p/:id',
          beforeEnter: (to, from, next) => {
            // if (/^[0-9]{8}$/.test(to.params.id)) {
            //   next(true)
            // } else if (/^[0-9]{9}$/.test(to.params.id)) {
            //   next({
            //     path: 't/' + to.params.id
            //   })
            // } else {
            //   next({
            //     path: '/'
            //   })
            // }
            if (/^[0-9]{8,10}$/.test(to.params.id)) {
              next(true)
            } else {
              next({
                path: '/'
              })
            }
          }
        },
        {
          path: 'tel/:telnumber',
          name: 'Tel',
          alias: '/t/:telnumber'
        },
        {
          path: 'create',
          name: 'Create'
        },
        {
          path: 'myplace/:latlonzoompageindex',
          name: 'MyPlace'
        }
      ]
    },
    {
      path: '/qr/place/:id',
      name: 'PlaceQr',
      alias: '/qr/p/:id',
      beforeEnter: (to, from, next) => {
        if (/^[0-9]{8}$/.test(to.params.id)) {
          next(true)
        } else {
          next({
            path: '/'
          })
        }
      },
      component: PlaceQr
    },
    {
      path: '/qr/uid/:id',
      name: 'UserQr',
      alias: '/qr/u/:id',
      beforeEnter: (to, from, next) => {
        if (/^[0-9]*$/.test(to.params.id)) {
          next(true)
        } else {
          next({
            path: '/'
          })
        }
      },
      component: UserQr
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js